import { createRoutesFromElements } from "react-router-dom";

import createSentryBrowserRouter from "../sentry/components/createSentryBrowserRouter";

import routes from "./routes";

const router = createSentryBrowserRouter(createRoutesFromElements(routes));

export default router;
